var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.viewMap)?_c('div',{staticClass:"cd__map"},[_c('GmapMap',{staticStyle:{"width":"100%","height":"400px"},attrs:{"center":{lat: +_vm.mapObject.latitude, lng: +_vm.mapObject.longitude},"zoom":10,"map-type-id":"roadmap","options":{
      scrollwheel: false
    }}},[_c('GmapMarker',{attrs:{"label":"★","position":{
          lat: +_vm.mapObject.latitude,
          lng: +_vm.mapObject.longitude,
        }}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }